/**
 * Non-production "Sign in as Service Member" demo login flag, resolved at RUNTIME.
 *
 * The web image is built once and promoted unchanged across environments, so this
 * cannot be a compile-time `import.meta.env.VITE_DEMO_LOGIN_ENABLED` constant —
 * esbuild would fold and tree-shake it, baking the same value into every
 * environment's bundle. Instead the value is emitted into index.html as a
 * `%VITE_DEMO_LOGIN_ENABLED%` placeholder and resolved per environment:
 *   - Local dev: Vite HTML env replacement substitutes the real value from
 *     .env.development.local (written by the Tiltfile).
 *   - Non-dev (test/stage/prod): the promoted image keeps the placeholder, which
 *     nginx rewrites to the environment-specific boolean at serve time via a
 *     sub_filter (see deploy-aks/charts/20-web-app).
 *
 * The flag MUST never resolve to 'true' in production.
 */
const resolveDemoLoginEnabled = (): boolean => {
  if (typeof document === 'undefined') return false;
  const content = document
    .querySelector('meta[name="equip-demo-login"]')
    ?.getAttribute('content');
  return content === 'true';
};

export const DEMO_LOGIN_ENABLED = resolveDemoLoginEnabled();
